/*
  Arrows, dots and auto slide for the image-hotspots panel.

  The section already has working hotspot buttons on the image and its own
  script that swaps the panel content when one is pressed. Rather than
  duplicate that, these controls simply click the relevant hotspot button —
  so which hotspot is active stays in one place and cannot drift.
*/

(function () {
  'use strict';

  function HotspotPanel(root) {
    this.root = root;
    this.buttons = Array.prototype.slice.call(root.querySelectorAll('.tooltip-button'));
    if (this.buttons.length < 2) return;

    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-hotspot-dot]'));
    this.index = 0;

    // Seconds between auto slides. The section only prints the attribute when
    // its auto slide setting is on, so 0 here means "don't auto slide".
    this.delay = parseFloat(root.getAttribute('data-hotspot-autoplay')) * 1000 || 0;

    var prev = root.querySelector('[data-hotspot-prev]');
    var next = root.querySelector('[data-hotspot-next]');
    if (prev) prev.addEventListener('click', this.step.bind(this, -1));
    if (next) next.addEventListener('click', this.step.bind(this, 1));

    this.dots.forEach(
      function (dot, i) {
        dot.addEventListener('click', this.go.bind(this, i));
      }.bind(this)
    );

    // A hotspot pressed directly on the image must move the dots too.
    // Every card change — arrow, dot, hotspot or the auto slide itself — ends
    // up here, so restarting the countdown here gives a shopper's own click a
    // full interval before the next auto slide.
    this.buttons.forEach(
      function (button, i) {
        button.addEventListener(
          'click',
          function () {
            this.index = i;
            this.paint();
            this.schedule();
          }.bind(this)
        );
      }.bind(this)
    );

    if (this.delay) this.autoplay();
    this.paint();
  }

  HotspotPanel.prototype.autoplay = function () {
    var panel = this.root.querySelector('.grid-item.right') || this.root;
    this.hovered = false;
    this.focused = false;
    this.visible = false;

    // Hold still while the mouse is over the card, so it can't change under
    // the cursor on the way to add to cart. Touch is left out: a tap fires
    // pointerenter as well, and would leave the slider stuck paused.
    panel.addEventListener(
      'pointerenter',
      function (e) {
        if (e.pointerType !== 'mouse') return;
        this.hovered = true;
        this.schedule();
      }.bind(this)
    );
    panel.addEventListener(
      'pointerleave',
      function (e) {
        if (e.pointerType !== 'mouse') return;
        this.hovered = false;
        this.schedule();
      }.bind(this)
    );

    // On touch screens there is no hover, so any tap on the card restarts the
    // countdown instead.
    panel.addEventListener('pointerdown', this.schedule.bind(this));

    // Same hold for keyboard users tabbing through the card. :focus-visible
    // stops a mouse click on an arrow from counting and pausing it for good.
    panel.addEventListener(
      'focusin',
      function (e) {
        if (!e.target.matches(':focus-visible')) return;
        this.focused = true;
        this.schedule();
      }.bind(this)
    );
    panel.addEventListener(
      'focusout',
      function (e) {
        if (panel.contains(e.relatedTarget)) return;
        this.focused = false;
        this.schedule();
      }.bind(this)
    );

    // Only count down while the section is on screen. Nobody sees it change
    // otherwise, and a shopper scrolling down meets the first card.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          this.visible = entries[0].isIntersecting;
          this.schedule();
        }.bind(this)
      ).observe(this.root);
    } else {
      this.visible = true;
      this.schedule();
    }
  };

  HotspotPanel.prototype.schedule = function () {
    clearTimeout(this.timer);
    // isConnected: the theme editor replaces the section on every change, and
    // the old copy's timer must not keep running behind it.
    if (!this.delay || !this.visible || this.hovered || this.focused || !this.root.isConnected) return;
    this.timer = setTimeout(this.step.bind(this, 1), this.delay);
  };

  HotspotPanel.prototype.go = function (i) {
    var count = this.buttons.length;
    // wrap, so the arrows never dead-end
    this.index = ((i % count) + count) % count;
    this.buttons[this.index].click();
    this.paint();
  };

  HotspotPanel.prototype.step = function (direction) {
    this.go(this.index + direction);
  };

  HotspotPanel.prototype.paint = function () {
    this.dots.forEach(
      function (dot, i) {
        dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
      }.bind(this)
    );
  };

  function init(scope) {
    (scope || document).querySelectorAll('image-hotspots').forEach(function (el) {
      if (el.hotspotPanel) return;
      el.hotspotPanel = new HotspotPanel(el);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init.bind(null, undefined));

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
